import { render, staticRenderFns } from "./RefuseOpportunity.vue?vue&type=template&id=37e880e1&scoped=true"
import script from "./RefuseOpportunity.vue?vue&type=script&lang=js"
export * from "./RefuseOpportunity.vue?vue&type=script&lang=js"
import style0 from "./RefuseOpportunity.vue?vue&type=style&index=0&id=37e880e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e880e1",
  null
  
)

export default component.exports